import React, { useEffect, useState } from "react";
import { FiUsers } from "react-icons/fi";
import { FaRegEye } from "react-icons/fa";

import axios  from "axios";
import {

  FaCoins,
 
} from "react-icons/fa";
import { MdOutlineMeetingRoom, MdOutlineNoMeetingRoom } from "react-icons/md";

// Optional: keep dummy data as fallback if API fails
const dummyRooms = [
  // ... your existing dummyRooms array (unchanged)
];

const ViewParticipantsModal = ({ isOpen, onClose, room }) => {
  if (!isOpen || !room) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex justify-center items-center z-50">
      <div className="bg-white border-2 border-gray-200 rounded-2xl p-6 w-full max-w-lg text-[var(--black-text)]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">
            Participants ({room.participantsList.length})
          </h2>
          <button className="text-[var(--primary-solid)] text-lg" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="space-y-3 max-h-80 overflow-y-auto">
          {room.participantsList.map((p, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 bg-white border-2 border-gray-200 rounded-xl p-3"
            >
              <FiUsers />
              <div>
                <div className="font-semibold">{p.name}</div>
                <div className="text-sm capitalize">
                  Role: <span className="font-semibold">{p.role}</span>
                </div>
                <div className="font-semibold capitalize">{p.gender}</div>
                <div className="text-sm text-gray-400">{p.joinedAt}</div>
              </div>
            </div>
          ))}
        </div>

        <button
          className="w-full mt-5 px-4 py-2 bg-[var(--yellow)] text-white rounded-xl"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

//
// -------------------- MAIN ROOMS COMPONENT --------------------
//
const Rooms = () => {
  const [rooms, setRooms] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");

  const [selectedRoom, setSelectedRoom] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 5;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");



  useEffect(() => {
  const fetchRooms = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await axios.get("/api/v1/app/group-call/list-rooms");

      if (res.data.status === "OK" && Array.isArray(res.data.data)) {

        const mapped = res.data.data.map((room) => {
          const participants = room.participants || [];
          const lastParticipant =
            participants.length > 0
              ? participants[participants.length - 1]
              : null;

          return {
            _id: room._id,
            hostName: room.hostId?.fullName || "Unknown Host",
            roomName: room.channelName || "Group Room",
            createdAt: room.createdAt,
            lastActive: lastParticipant?.joinedAt || room.createdAt,
            roomType:
              room.roomType === "group_audio"
                ? "audio"
                : room.roomType === "group_video"
                ? "video"
                : room.roomType,
            status: room.status,
            rawParticipants: participants,
          };
        });

        setRooms(mapped);
      } else {
        setRooms(dummyRooms);
      }
    } catch (err) {
      console.log("API ERROR:", err);
      setError("Failed to load rooms");
      setRooms(dummyRooms);
    } finally {
      setLoading(false);
    }
  };

  fetchRooms();
}, []);


  // Filter logic
  const filteredRooms = rooms
    .filter((room) =>
      room.hostName.toLowerCase().includes(search.toLowerCase())
    )
    .filter((room) =>
      statusFilter === "all" ? true : room.status === statusFilter
    )
    .filter((room) =>
      typeFilter === "all" ? true : room.roomType === typeFilter
    );

  const totalPages = Math.ceil(filteredRooms.length / limit) || 1;
  const paginatedRooms = filteredRooms.slice(
    (currentPage - 1) * limit,
    currentPage * limit
  );

  // Dashboard
  const dashboard = {
    total: rooms.length,
    active: rooms.filter((r) => r.status === "active").length,
    inactive: rooms.filter((r) => r.status === "inactive").length,
  };

const formatNumber = (n) => {
  if (n === 0) return 0;     
  return n ? n.toLocaleString("en-IN") : 0;
};


  return (
    <div className="p-5 text-[var(--black-text)]">
      <div className="bg-white border-2 border-gray-200 rounded-xl shadow-sm">

        {/* Header Section */}
        <div className="p-6">
          <div className="flex justify-between items-center">
            <h1 className="text-3xl md:text-4xl font-bold text-[var(--primary-solid)]">
             Room Management
            </h1>
          </div>
          <p className="text-[var(--black-text)]/70 mt-2">
            Manage user Audio & Video Room calls
          </p>
        </div>

        {/* Stats Section */}
        <div className="px-6 pb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatCard
          title="Total Rooms"
          value={`${formatNumber(dashboard.total)}`}
          icon={<FaCoins />}
          color="yellow"
        />
        <StatCard
          title="Active Rooms"
          value={formatNumber(dashboard.active)}
          icon={<MdOutlineMeetingRoom />}
          color="green"
        />
        <StatCard
          title="Inactive Rooms"
          value={formatNumber(dashboard.inactive) || 0}
          icon={<MdOutlineNoMeetingRoom />}
          color="red"
        />
          </div>
        </div>

        {/* Separator */}
        <div className="border-t border-gray-200"></div>

        {/* Search + Filters */}
        <div className="p-6">
          <div className="flex flex-col md:flex-row gap-4">
          <input
            className="w-full px-4 py-2 bg-white border-2 border-gray-200 rounded-xl text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
            placeholder="Search by host name..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />

          <select
            className="px-4 py-2 bg-white border-2 border-gray-200 rounded-xl text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] focus:outline-none"
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="all">All Status</option>
            <option value="active">Active Rooms</option>
            <option value="inactive">Inactive Rooms</option>
          </select>

          <select
            className="px-4 py-2 bg-white border-2 border-gray-200 rounded-xl text-[var(--black-text)] focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] focus:outline-none"
            value={typeFilter}
            onChange={(e) => {
              setTypeFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="all">All Types</option>
            <option value="audio">Audio Rooms</option>
            <option value="video">Video Rooms</option>
          </select>
        </div>

        {loading && (
          <p className="mt-3 text-sm text-gray-400">Loading rooms from API...</p>
        )}
        {error && (
          <p className="mt-2 text-sm text-red-400">
            {error}
          </p>
          )}
        </div>

        {/* Separator */}
        <div className="border-t border-gray-200 my-6"></div>

        {/* Rooms Table */}
        <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-max table-auto whitespace-nowrap">
          <thead className="bg-[var(--yellow)] text-white uppercase text-xs">
            <tr>
              <th className=" p-3 text-center">Host</th>
              <th className="p-3 text-center">Room Name</th>
              <th className="p-3 text-center">Status</th>
              <th className="p-3 text-center">Type</th>
              <th className="p-3 text-center">Created</th>
              <th className="p-3 text-center">Last Active</th>
              <th className="p-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {paginatedRooms.map((room) => (
              <tr
                key={room._id}
                className="border-t border-gray-200 hover:bg-[var(--primary-solid)] hover:text-white transition gap-3 p-5 m-5"
              >
                <td className="p-5 ml-3  text-center">{room.hostName}</td>
                <td className="p-5  text-center">{room.roomName}</td>
                <td className="p-5  text-center">
                  <span
                    className={`px-2 py-1 text-xs  text-center rounded-full ${
                      room.status === "active"
                        ? "bg-green-600 text-white"
                        : "bg-red-600 text-white"
                    }`}
                  >
                    {room.status}
                  </span>
                </td>

                <td className="p-5 text-center capitalize">{room.roomType}</td>
                <td className="p-5 text-center">
                  {room.createdAt
                    ? new Date(room.createdAt).toLocaleDateString()
                    : "N/A"}
                </td>
                <td className="p-5  text-center">
                  {room.lastActive
                    ? new Date(room.lastActive).toLocaleString()
                    : "N/A"}
                </td>

                <td className="p-5 text-center flex g flex-wrap">
                  {/* View Participants */}
                  <button
                    className="flex items-center gap-1"
                    onClick={() => {
                      const participantsList = (room.rawParticipants || []).map(
                        (p) => ({
                          name:
                            p.name ||
                            p.userName ||
                            (p.role === "host"
                              ? `Host - ${room.hostName}`
                              : p.userId),
                          gender: p.gender || "N/A",
                          joinedAt: p.joinedAt || "N/A",
                          role: p.role || "member",
                        })
                      );

                      setSelectedRoom({ ...room, participantsList });
                      setViewModalOpen(true);
                    }}
                  >
                    <FaRegEye /> View
                  </button>
                </td>
              </tr>
            ))}

            {paginatedRooms.length === 0 && !loading && (
              <tr>
                <td
                  colSpan={7}
                  className="text-center py-6 text-gray-400 text-sm"
                >
                  No rooms found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="p-4 flex justify-between items-center text-sm">
          <span>
            Page {currentPage} of {totalPages}
          </span>

          <div className="flex gap-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              className="px-3 py-1 border-2 border-gray-200 rounded disabled:opacity-40 text-[var(--black-text)] hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white"
            >
              Prev
            </button>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              className="px-3 py-1 border-2 border-gray-200 rounded disabled:opacity-40 text-[var(--black-text)] hover:bg-gradient-to-r hover:from-[var(--primary-solid)] hover:to-[var(--primary-dark)] hover:text-white"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* View Participants Modal */}
      {viewModalOpen && selectedRoom && (
        <ViewParticipantsModal
          isOpen={viewModalOpen}
          onClose={() => setViewModalOpen(false)}
          room={selectedRoom}
        />
      )}

      </div>
    </div>
  );
};

export default Rooms;

const StatCard = ({ title, value, icon, color = "yellow" }) => {
  const colorClasses = {
    yellow: {
      bg: "bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-[var(--yellow)]/20",
      text: "text-[var(--yellow)]",
      icon: "text-[var(--yellow)]"
    },
    green: {
      bg: "bg-gradient-to-br from-green-500/10 to-green-500/5 border-green-500/20",
      text: "text-green-400",
      icon: "text-green-400"
    },
    red: {
      bg: "bg-gradient-to-br from-red-500/10 to-red-500/5 border-red-500/20",
      text: "text-red-400",
      icon: "text-red-400"
    }
  };

  return (
    <div className={`${colorClasses[color].bg} rounded-xl p-4 shadow-lg border-2`}>
      <div className="flex items-center justify-between">
        <div>
          <p className={`text-xs font-medium ${colorClasses[color].text} uppercase tracking-wider`}>
            {title}
          </p>
          <p className={`text-2xl font-bold ${colorClasses[color].text}`}>
            {value}
          </p>
        </div>
        <div className={`text-3xl ${colorClasses[color].icon}`}>
          {icon}
        </div>
      </div>
    </div>
  );
};
